<script setup>
import HeaderNav from "@/components/headerNav.vue";
import FootNav from "@/components/footNav.vue";
import { ref, } from 'vue'
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
import {getBannerApi,getNewsArticleTypeApi  } from "@/api";
import router from "@/router";
const bannerList = ref([ ]),pageNo = ref(1),total = ref(0)
function  getBanner (){
  getBannerApi({type:7}).then(res => {
    bannerList.value = res.data
  })
}
function  getNewsArticleType( ) {

  getNewsArticleTypeApi({pageNo :pageNo.value, pageSize:10,type:7}).then(res=>{
    videos.value = res.data.list
    total.value = res.data.total
  })
}
// 视频数据（可替换为 API 请求）
const videos = ref([
])

function goDetails(id) {
  console.log(id)
  router.push({
    path: `/caseDetails`,
    query: {  id }
  })
}
getBanner()
getNewsArticleType()

</script>

<template>
  <div class="box">
    <HeaderNav :isCurrent="6" />
    <div>
      <!-- 轮播图 -->
      <el-carousel height="auto" autoplay>
        <el-carousel-item style="height: auto ;min-height: 600px" v-for="(item ,index) in bannerList" :key="index">
          <img :src="item.picUrl" :alt="item.title">
        </el-carousel-item>
      </el-carousel>
    </div>
    <div>
      <div class="video">
        <!-- 右侧区域 开始 -->
        <div id="right">
          <div class="right_title">
            <!-- 当前位置 开始 -->
            <div id="location">
              <a href="/" target="_self">{{t('首页')}}</a> &nbsp;&gt;&gt;&nbsp;
              <a href="javascript:;">{{t('客户案例')}}</a>
            </div>
          </div>
          <div id="subchannel_main">
            <div id="subchannel">
              <ul class="subchannellist">
                <li class="depth1" id="current">
                  <a href="javascript:;">客户案例</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="right_body minwidth">
            <ul id="videoList" class="videolist">
              <!-- 使用 v-for 循环渲染视频项 -->
              <li
                  v-for="video in videos"
                  :key="video.id"
                  class='animate__animated animate__fadeInUp'
                  @click="goDetails(video.id)"
              >
                <div class="padding-5 pointer">
                  <img
                      :src="video.picUrl"
                      :title="video.title"
                      :alt="video.title"
                  />
                </div>
                <div class="InfoTitle">
                  <span
                      class="InfoTitle_video_a"

                  >
                    {{ video.title }}
                  </span>
                </div>
              </li>
            </ul>

          </div>
          <!-- 分页保持不变 -->
          <div class="page_custom">
            <el-pagination background layout="prev, pager, next" :total="total" />
          </div>
          <div class="right_bottom"></div>
        </div>
        <!-- 右侧区域 结束 -->
        <div class="clear"></div>
      </div>
    </div>
    <div>
      <FootNav />
    </div>
  </div>
</template>
<style scoped lang="scss">
/* 可选：初始隐藏，让动画更明显 */

.InfoTitle_video_a {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
}

</style>
